import { render, staticRenderFns } from "./department-dialog.vue?vue&type=template&id=ce9b8024&"
import script from "./department-dialog.vue?vue&type=script&lang=js&"
export * from "./department-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "department-dialog.vue"
export default component.exports